<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :multiple="multiple"
    :placeholder="placeholder"
    :value="value"
    @input="(status) => $emit('input', status)"
    :reduce="(status) => status.value"
  />
</template>
<script>
export default {
  name: 'SubStatusSelect',
  props: {
    value: String,
    id: {
      type: String,
      default: 'sub-status-select',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'Select a Sub Status',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getSubStatusOptions();
  },
  methods: {
    getSubStatusOptions() {
      this.$store.cache.dispatch('getWorkOrderSubStatuses').then((subStatusOptions) => {

        this.options = subStatusOptions.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
  },
};
</script>
